import { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Webcam from 'react-webcam';
import BtnGradient from 'src/components/common/button/BtnGradient';

const FACING_MODE_USER = 'user';
const FACING_MODE_ENVIRONMENT = 'environment';

const DialogCamera = (props: any) => {
  const [facingMode, setFacingMode] = useState(FACING_MODE_USER);
  const [hasMultipleCameras, setHasMultipleCameras] = useState(false);
  const webcamRef = useRef<Webcam>(null);
  const capture = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      props.handleCaptureImage(imageSrc);
    }
  };

  const switchCamera = () => {
    setFacingMode((prev) =>
      prev === FACING_MODE_USER ? FACING_MODE_ENVIRONMENT : FACING_MODE_USER
    );
  };

  useEffect(() => {
    const checkCameras = async () => {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        console.log('Available devices:', devices);
        const videoInputs = devices.filter(
          (device) => device.kind === 'videoinput'
        );
        setHasMultipleCameras(videoInputs.length > 1);
      } catch (err) {
        console.error('Error enumerating devices:', err);
      }
    };

    if (props.openDialogCamera) {
      checkCameras();
    }
  }, [props.openDialogCamera]);

  return (
    <Dialog
      open={props.openDialogCamera}
      onClose={props.handleCloseDialogCamera}
      scroll='paper'
      aria-labelledby='scroll-dialog-title'
      aria-describedby='scroll-dialog-description'
      sx={{
        '& .MuiPaper-root.MuiPaper-elevation.MuiDialog-paper': {
          width: '100%',
          maxWidth: '770px',
        },
      }}
    >
      <DialogTitle id='scroll-dialog-title' sx={{ p: '32px', pb: '16px' }}>
        <Typography fontSize={'20px'} fontWeight={500}>
          カメラ
        </Typography>
      </DialogTitle>
      <Box
        component='img'
        src='/images/icons/ic-close.svg'
        alt='icon close'
        onClick={props.handleCloseDialogCamera}
        sx={{
          position: 'absolute',
          right: '32px',
          top: '32px',
          cursor: 'pointer',
        }}
      />
      <DialogContent>
        <Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat='image/jpeg'
          style={{
            width: '100%',
            height: 'calc(100vh - 250px)',
          }}
          videoConstraints={{
            facingMode,
          }}
        />
        <Stack alignItems='center' justifyContent='center' direction='row' spacing='10px'>
          <BtnGradient
            text='撮影'
            width='150px'
            handleButtonClick={capture}
          />
          {hasMultipleCameras && (
            <BtnGradient
              text="切替"
              width="150px"
              handleButtonClick={switchCamera}
            />
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default DialogCamera;
